/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const arrowDown = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24">
		<Path d="M9 2h2v12l4-4 2 1-7 7-7-7 2-1 4 4V2z" />
	</SVG>
);

export default arrowDown;
